import BaseApiRequest from "./BaseApiRequest";
import { GET_APPLICANT_DETAILS } from "../ApiUrls";
import { METHOD } from "../Constants";

export default class GetApplicationRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_APPLICANT_DETAILS;

  constructor(id) {
    super();
    this.url = this.url.concat(id);
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return this.url;
  };

  getBody = () => {
    return this.body;
  };
}
